/**
 * @generated SignedSource<<7fd3602c6ee86087978e17812285778f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductAppVisibility = "admin" | "all" | "membership" | "%future added value";
export type CreateEventFormQuery$variables = {
  appId: string;
  organizationId: string;
  productId: string;
};
export type CreateEventFormQuery$data = {
  readonly app: {
    readonly __typename: string;
    readonly id: string;
    readonly visibility?: ProductAppVisibility;
    readonly visibilityGroups?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_AppFragment">;
  } | null;
  readonly organization: {
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_OrganizationFragment" | "EventMeetingFormFields_OrganizationFragment">;
  } | null;
  readonly product: {
    readonly __typename: string;
    readonly createdByUserMembership?: {
      readonly id: string;
    } | null;
    readonly id: string;
    readonly name?: string;
    readonly viewerMembership?: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"EventAccessFormFields_ProductFragment" | "EventMeetingFormFields_ProductFragment">;
  } | null;
};
export type CreateEventFormQuery = {
  response: CreateEventFormQuery$data;
  variables: CreateEventFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "createdByUserMembership",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "viewerMembership",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsMember",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMemberGroupId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberGroupNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroupNodeConnection",
            "kind": "LinkedField",
            "name": "childrenGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "platform",
      "value": "zoom"
    }
  ],
  "concreteType": "MeetingProviderNodeConnection",
  "kind": "LinkedField",
  "name": "meetingProviders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingProviderNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingProvider",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ZoomConnection",
              "kind": "LinkedField",
              "name": "zoomConnection",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "picUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userPlanType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasWebinarAddon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "meetingCapacity",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webinarCapacity",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isConnected",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Organization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasZoomIntegration",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "avatar",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTest",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "meetingProviders(platform:\"zoom\")"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEventFormQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventAccessFormFields_ProductFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventMeetingFormFields_ProductFragment"
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "organization",
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventAccessFormFields_OrganizationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventMeetingFormFields_OrganizationFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "app",
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "visibilityGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventAccessFormFields_AppFragment"
              }
            ],
            "type": "ProductApp",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateEventFormQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registrationAvailability",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "kind",
                    "value": "custom"
                  }
                ],
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroups",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "memberGroups(kind:\"custom\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "organization",
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "allMemberGroups",
                    "value": true
                  }
                ],
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroups",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "memberGroups(allMemberGroups:true)"
              },
              (v21/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "app",
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "visibilityGroups",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              }
            ],
            "type": "ProductApp",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc2e7d6cc56f193577ff5dba4da305bb",
    "id": null,
    "metadata": {},
    "name": "CreateEventFormQuery",
    "operationKind": "query",
    "text": "query CreateEventFormQuery(\n  $productId: ID!\n  $organizationId: ID!\n  $appId: ID!\n) {\n  product: node(id: $productId) {\n    id\n    __typename\n    ... on Product {\n      name\n      ...EventAccessFormFields_ProductFragment\n      ...EventMeetingFormFields_ProductFragment\n      createdByUserMembership {\n        id\n      }\n      viewerMembership {\n        id\n      }\n    }\n  }\n  organization: node(id: $organizationId) {\n    id\n    __typename\n    ... on Organization {\n      ...EventAccessFormFields_OrganizationFragment\n      ...EventMeetingFormFields_OrganizationFragment\n    }\n  }\n  app: node(id: $appId) {\n    id\n    __typename\n    ... on ProductApp {\n      visibility\n      visibilityGroups {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      ...EventAccessFormFields_AppFragment\n    }\n  }\n}\n\nfragment EventAccessFormFields_AppFragment on ProductApp {\n  visibility\n  ...MemberGroupsMultiSelect_AppFragment\n}\n\nfragment EventAccessFormFields_OrganizationFragment on Organization {\n  name\n  ...MemberGroupsMultiSelect_OrganizationFragment\n}\n\nfragment EventAccessFormFields_ProductFragment on Product {\n  name\n  registrationAvailability\n  type\n  ...MemberGroupsMultiSelect_ProductFragment\n}\n\nfragment EventMeetingFormFields_OrganizationFragment on Organization {\n  id\n  meetingProviders(platform: zoom) {\n    edges {\n      node {\n        id\n        ...OrganizationZoomConnectionListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventMeetingFormFields_ProductFragment on Product {\n  id\n  organization {\n    meetingProviders(platform: zoom) {\n      edges {\n        node {\n          id\n          ...OrganizationZoomConnectionListItemFragment\n        }\n      }\n    }\n    id\n  }\n  ...OccurrencePhysicalAddressInput_ProductFragment\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MemberGroupsMultiSelect_AppFragment on ProductApp {\n  id\n  visibilityGroups {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MemberGroupsMultiSelect_OrganizationFragment on Organization {\n  memberGroups(allMemberGroups: true) {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MemberGroupsMultiSelect_ProductFragment on Product {\n  id\n  memberGroups(kind: custom) {\n    edges {\n      node {\n        id\n        name\n        color\n        viewerIsMember\n        kind\n        isSystem\n        parentMemberGroupId\n        visibility\n        product {\n          id\n          name\n          type\n        }\n        ...MemberGroupTagFragment\n        childrenGroups {\n          totalCount\n          edges {\n            node {\n              id\n              name\n              color\n              viewerIsMember\n              kind\n              parentMemberGroupId\n              visibility\n              product {\n                id\n                name\n              }\n              ...MemberGroupTagFragment\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OccurrencePhysicalAddressInput_ProductFragment on Product {\n  id\n}\n\nfragment OrganizationZoomConnectionListItemFragment on MeetingProvider {\n  id\n  zoomConnection {\n    id\n    email\n    firstName\n    lastName\n    picUrl\n    userPlanType\n    hasWebinarAddon\n    meetingCapacity\n    webinarCapacity\n    isConnected\n  }\n  organization {\n    id\n    hasZoomIntegration\n  }\n  user {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n"
  }
};
})();

(node as any).hash = "49e7a1b6bc677de0dbb94f05b1fedc09";

export default node;
